var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaims(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.45605 1.74805C7.80575 1.61206 8.19426 1.61206 8.54395 1.74805L12.832 3.41602C13.2345 3.57252 13.5 3.9598 13.5 4.3916V5.95996C13.5 9.21247 11.7723 12.2205 8.96289 13.8594C8.36785 14.2064 7.63215 14.2064 7.03711 13.8594C4.22766 12.2205 2.5 9.21247 2.5 5.95996V4.3916C2.5 3.9598 2.76553 3.57252 3.16797 3.41602L7.45605 1.74805Z",
    stroke: "#002A69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 5.5H8M6 9.5H8M8 5.5H7C6.44772 5.5 6 5.94772 6 6.5C6 7.05228 6.44772 7.5 7 7.5H9C9.55228 7.5 10 7.94772 10 8.5C10 9.05228 9.55228 9.5 9 9.5H8M8 5.5V4.5M8 9.5V10.5",
    stroke: "#002A69",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaims);
export default __webpack_public_path__ + "static/media/Claims.f25ff96ea794fcba14d8d23f4b4642b4.svg";
export { ForwardRef as ReactComponent };